var map = {
	"./api.png": "15d4",
	"./document.png": "b44c",
	"./facebook.png": "b275",
	"./news.png": "b9c3",
	"./toutiao.png": "f8dd",
	"./twitter.png": "20a0",
	"./weibo.png": "4eff",
	"./youtube.png": "abe2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4301";